import {Component, Input, OnInit} from '@angular/core';
import {NavService} from '../../../../_services/_nav.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {ListaItem} from '../../../../_models/lista-item';
import {forkJoin} from 'rxjs';
import {ListaService} from '../../../../_services/lista.service';
import {NivelesService} from '../../../../_services/niveles.service';
import {RolesService} from '../../../../_services/roles.service';
import {TalanqueraService} from '../../../../_services/talanquera.service';
import {Politica} from '../../../../_models/politica';
import {PoliticaTalanquera} from '../../../../_models/talanquera';
import {EstadoService} from '../../../../_services/estado.service';
import {FaseEstado} from '../../../../_models/fase-estado';
import {PoliticaService} from '../../../../_services/politica.service';

@Component({
  selector: 'app-politica-talanquera',
  templateUrl: './politica-talanquera.component.html',
  styleUrls: ['./politica-talanquera.component.scss']
})
export class PoliticaTalanqueraComponent implements OnInit {
  @Input() politica: Politica;
  @Input() esDetalle: boolean = false;

  cargando: boolean = false;
  guardando: boolean = false;
  guardandoExcepcion: boolean = false;
  submitted: boolean = false;
  submittedExcepcion: boolean = false;
  submittedEstadoDetener: boolean = false;
  guardandoEstadoDetener: boolean = false;
  formulario: FormGroup;
  formularioDetener: FormGroup;
  columnasExcepcion: any[];
  columnasDetener: any[];
  listasReglasTalanquera: SelectItem[] = [];
  listasReglasTalanqueraTodas: ListaItem[] = [];
  listasTiposVinculaciones: SelectItem[] = [];
  listasTiposVinculacionesDetener: SelectItem[] = [];
  listasTiposVinculacionesExcepcion: SelectItem[] = [];
  listasTiposVinculacionesTodas: ListaItem[] = [];
  listasRespaldos: SelectItem[] = [];
  listasRespaldosTodas: ListaItem[] = [];
  listaNiveles: SelectItem[] = [];
  listaNivelesTodas: ListaItem[] = [];
  listaRoles: SelectItem[] = [];
  listaRolesTodas: ListaItem[] = [];

  registrosExcepcion: PoliticaTalanquera[] = [];
  registrosDetener: PoliticaTalanquera[] = [];

  lIstasCausalesSolicitudesTodas: ListaItem[] = [];
  lIstasCausalesSolicitudes: SelectItem[] = [];

  listaEstadosTodas: ListaItem[] = [];
  listaEstados: SelectItem[] = [];

  item: any
  itemSeleccionado: any

  indicadoManejaAdjunto: boolean = false;

  estadoDetener: any;

  habilitarEdicionEstado: boolean = true;

  constructor(
    private fb: FormBuilder,
    private nav: NavService,
    private lisServicio: ListaService,
    private nivelesService: NivelesService,
    private rolServicio: RolesService,
    private talanqueraService: TalanqueraService,
    private estadoService: EstadoService,
    private conServicio: ConfirmationService,
    private navServicio: NavService,
    private politicaService: PoliticaService
  ) {}

  async ngOnInit() {
    this.cargando = true;
    this.cargarFormulario();
    await this.cargarInformacion();
    setTimeout( () => {
      if (this.politica && this.politica.idEstado) {
        this.estadoDetener = this.politica.idEstado;
        this.habilitarEdicionEstado = false;
      }
      this.cargando = false;
    }, 1000 );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      id: [ null ],
      regla: [ null, [ Validators.required ] ],
      vinculacion: [ null, [ Validators.required ] ],
      manejaAdjunto: [ false, [ Validators.required ] ],
      adjunto: [ null ],
      nivel: [ null, [ Validators.required ] ],
      definicioExcepcion: [ null, [ Validators.required ] ],
      rol: [ null, [ ] ],
    } );

    this.formularioDetener = this.fb.group( {
      id: [ null ],
      regla: [ null, [ Validators.required ] ],
      vinculacion: [ null, [ Validators.required ] ],
      causal: [ null, [ Validators.required ] ],
      // estado: [ null, [ Validators.required ] ],
    } );
}

  get f() {
    return this.formulario.controls;
  }

  get fDetener() {
    return this.formularioDetener.controls;
  }

  async cargarInformacion() {
    this.listasReglasTalanquera = [];

    forkJoin(
      this.lisServicio.getMasterDetails('ListasReglasTalanquera'),
      this.lisServicio.getMasterDetails('ListasTiposVinculaciones'),
      this.lisServicio.getMasterDetails('ListasRespaldos'),
      this.nivelesService.listado(),
      this.rolServicio.listRolesEnabled(),
      this.lisServicio.getMasterDetails('ListasCausalesSolicitudes'),
      this.estadoService.listadoHabilitados(),
    ).subscribe(
      async ([
        listasReglasTalanquera,
        listasTiposVinculaciones,
        listasRespaldos,
        listaNiveles,
        listaRoles,
        lIstasCausalesSolicitudes,
        listaEstados
     ]) => {
        this.listasReglasTalanqueraTodas = listasReglasTalanquera;
        listasReglasTalanquera.map((x) => {
          this.listasReglasTalanquera.push({
            label: x.nombre,
            value: x.idLista,
          });
        });
        this.listasTiposVinculacionesTodas = listasTiposVinculaciones;
        listasTiposVinculaciones.map((x) => {
          this.listasTiposVinculaciones.push({
            label: x.nombre,
            value: x.idLista,
          });
        });
        this.listasTiposVinculacionesDetener = this.listasTiposVinculaciones;
        this.listasTiposVinculacionesExcepcion = this.listasTiposVinculaciones;
        this.listasRespaldosTodas = listasRespaldos;
        listasRespaldos.map((x) => {
          this.listasRespaldos.push({
            label: x.nombre,
            value: x.idLista,
          });
        });
        // this.listaNivelesTodas = listaNiveles;
        listaNiveles.map((x) => {
          this.listaNiveles.push({
            label: x.nombre,
            value: x.idNivel,
          });
        });
        // this.listaRolesTodas = listaRoles;
        listaRoles.map((x) => {
          this.listaRoles.push({
            label: x.nombre,
            value: x.idRol,
          });
        });

        this.lIstasCausalesSolicitudesTodas = lIstasCausalesSolicitudes;
        lIstasCausalesSolicitudes.map((x) => {
          this.lIstasCausalesSolicitudes.push({
            label: x.nombre,
            value: x.idLista,
          });
        });

        // this.listaEstadosTodas = listaEstados;
        listaEstados.map((x) => {
          if (x.indicadorHabilitado && x.indicadorEstadoFinal) {
          this.listaEstados.push({
            label: x.nombre,
            value: x.idEstado,
          });
          }
        });
      }
    );

    if (this.politica && this.politica.idPolitica) {
      const listaTalanquera = await this.talanqueraService.listado(this.politica.idPolitica).toPromise();

      if (listaTalanquera) {
        this.registrosExcepcion = listaTalanquera.filter(item => item.indicadorDetener === false);
        this.registrosDetener = listaTalanquera.filter(item => item.indicadorDetener === true);
      }
    }

    this.columnasExcepcion = [
      { field: "vinculacion", header: this.nav.buscarMensaje("TALANQUERA.LBL_VINCULACION"), sort: true },
      { field: "regla", header: this.nav.buscarMensaje("TALANQUERA.LBL_REGLAS"), sort: true },
      { field: "indicadorAdjunto", header: this.nav.buscarMensaje("TALANQUERA.LBL_MANEJAADJUNTO"), sort: true },
      { field: "respaldo", header: this.nav.buscarMensaje("TALANQUERA.LBL_ADJUNTO"), sort: true },
      { field: "nivel", header: this.nav.buscarMensaje("TALANQUERA.LBL_NIVEL"), sort: true },
      { field: "roles", header: this.nav.buscarMensaje("TALANQUERA.LBL_ROLES"), sort: true },
      { field: "definicionExcepcion", header: this.nav.buscarMensaje("TALANQUERA.LBL_EXCEPCION"), sort: true }
    ];

    this.columnasDetener = [
      { field: "vinculacion", header: this.nav.buscarMensaje("TALANQUERA.LBL_VINCULACION"), sort: true },
      { field: "regla", header: this.nav.buscarMensaje("TALANQUERA.LBL_REGLAS"), sort: true },
      // { field: "estado", header: this.nav.buscarMensaje("TALANQUERA.LBL_ESTADO"), sort: false },
      { field: "causal", header: this.nav.buscarMensaje("TALANQUERA.LBL_CAUSAL"), sort: true }
    ];

    if (!this.esDetalle) {
      this.columnasExcepcion.push(
        { field: "acciones", header: this.nav.buscarMensaje("LBL_ACCIONES"), sort: false }
      )
      this.columnasDetener.push(
        { field: "acciones", header: this.nav.buscarMensaje("LBL_ACCIONES"), sort: false }
      )
    }
  }

  filtrarVinculacionesNoConfiguradas() {
    const reglaSeleccionadaId = this.formularioDetener.get('regla')?.value;
    if (!reglaSeleccionadaId) return;

    // Filtrar los ítems configurados que corresponden a la regla seleccionada
    const itemsConfiguradosPorRegla = this.registrosDetener.filter(item => item.idRegla === reglaSeleccionadaId);

    // Obtener los IDs de las vinculaciones ya configuradas para esa regla
    const vinculacionesConfiguradas = itemsConfiguradosPorRegla.map(item => item.idTipoVinculacion);

    // Filtrar las vinculaciones que no están en la lista de vinculaciones configuradas
    const vinculacionesNoConfiguradas = this.listasTiposVinculaciones.filter(
      vinculacion => !vinculacionesConfiguradas.includes(vinculacion.value)
    );

    this.listasTiposVinculacionesDetener = vinculacionesNoConfiguradas;

    // return vinculacionesNoConfiguradas;
  }

  async agregarDetener() {
    this.submitted = true;

    if(!this.politica || !this.politica.idPolitica) {
      this.nav.setMesage(4, {
        severity: "info",
        summary: this.nav.buscarMensaje("LBL_INFORMACION"),
        detail: this.nav.buscarMensaje("TALANQUERA.MSG_GUARDARPOLITICA"),
      });
      return;
    }

    if (this.formularioDetener.invalid) {
      this.formularioDetener.markAllAsTouched();
      return;
    }

    this.guardando = true;

    const formData = this.formularioDetener.value;

    if (formData.vinculacion.length > 1) {
      const objeto = formData.vinculacion.map(idTipoVinculacion => ({
        idPolitica: this.politica.idPolitica,
        idRegla: formData.regla,
        idTipoVinculacion: idTipoVinculacion,
        idCausal: formData.causal,
        // idEstado: formData.estado,
        indicadorDetener: true
      }));
      try {
        let response;
        response = await this.talanqueraService.guardarBulk(objeto).toPromise();
        this.actualizarListados();
        this.limpiarFormulario()
      } catch (error) {
        console.error('Error submitting data:', error);
      } finally {
        this.submitted = false;
        this.guardando = false;
      }
    } else {
      const objeto = {
        idPolitica: this.politica.idPolitica,
        idRegla: formData.regla,
        idTipoVinculacion: formData.vinculacion[0],
        idCausal: formData.causal,
        // idEstado: formData.estado,
        indicadorDetener: true
      }
      try {
        let response;
        response = await this.talanqueraService.guardar(objeto).toPromise();
        this.actualizarListados();
        this.limpiarFormulario();
      } catch (error) {
        console.error('Error submitting data:', error);
      } finally {
        this.submitted = false;
        this.guardando = false;
      }
    }
  }

  async editarDetener(){
    if (this.formularioDetener.invalid) {
      this.formularioDetener.markAllAsTouched();
      return;
    }

    this.guardando = true;
    this.submitted = true;

    const formData = this.formularioDetener.value;

    const objeto = {
      idPoliticaTalanquera: this.politica.idPolitica,
      idPolitica: this.politica.idPolitica,
      idRegla: this.itemSeleccionado.idRegla,
      idTipoVinculacion: this.itemSeleccionado.idTipoVinculacion,
      idCausal: formData.causal,
      // idEstado: formData.estado,
      indicadorDetener: true
    }
    try {
      let response;
      response = await this.talanqueraService.actualizar(objeto).toPromise();
      this.actualizarListados();
      this.limpiarFormulario()
    } catch (error) {
      console.error('Error submitting data:', error);
    } finally {
      this.submitted = false;
      this.guardando = false;
    }
  }

  editarPoliticaDetener(item) {
    if (item) {
      this.fDetener.id.setValue( item.idPoliticaTalanquera );
      this.fDetener.regla.setValue( item.idRegla );
      this.fDetener.vinculacion.setValue( [item.idTipoVinculacion] );
      this.fDetener.causal.setValue( item.idCausal );
      // this.fDetener.estado.setValue( item.idEstado );
      this.formularioDetener.get('regla')?.disable();
      this.formularioDetener.get('vinculacion')?.disable();
    }
    this.itemSeleccionado = item;
  }

  inhabilitarPoliticaDetener( registro ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'inhabilitar',
      accept: async () => {
        this.guardando = true;
        const objeto = registro;
        objeto.indicadorHabilitado = false;
        try {
          let response;
          response = await this.talanqueraService.actualizar(objeto).toPromise();
          this.actualizarListados();
          this.limpiarFormulario();
        } catch (error) {
          console.error('Error submitting data:', error);
        } finally {
          this.guardando = false;
        }
      },
      reject: () => {
      }
    } );
  }

  limpiarFormulario() {
    // Reinicia los valores del formulario
    this.formularioDetener.reset();

    // Habilita todos los campos del formulario
    Object.keys(this.formularioDetener.controls).forEach((campo) => {
      this.formularioDetener.get(campo)?.enable();
    });

    // Limpiar el item seleccionado
    this.itemSeleccionado = null;
    this.submitted = false;
    this.submittedEstadoDetener = false;
    this.listasTiposVinculacionesDetener = this.listasTiposVinculaciones;
    this.listasTiposVinculacionesExcepcion = this.listasTiposVinculaciones;
  }

  filtrarVinculacionesExcepcionNoConfiguradas() {
    const reglaSeleccionadaId = this.formulario.get('regla')?.value;
    if (!reglaSeleccionadaId) return;

    // Filtrar los ítems configurados que corresponden a la regla seleccionada
    const itemsConfiguradosPorRegla = this.registrosExcepcion.filter(item => item.idRegla === reglaSeleccionadaId);

    // Obtener los IDs de las vinculaciones ya configuradas para esa regla
    const vinculacionesConfiguradas = itemsConfiguradosPorRegla.map(item => item.idTipoVinculacion);

    // Filtrar las vinculaciones que no están en la lista de vinculaciones configuradas
    const vinculacionesNoConfiguradas = this.listasTiposVinculaciones.filter(
      vinculacion => !vinculacionesConfiguradas.includes(vinculacion.value)
    );

    this.listasTiposVinculacionesExcepcion = vinculacionesNoConfiguradas;

    // return vinculacionesNoConfiguradas;
  }

  validarAdjunto() {
    this.indicadoManejaAdjunto = this.formulario.get('manejaAdjunto')?.value;
    if (!this.indicadoManejaAdjunto) {
      this.f.adjunto.setValidators( null );
      this.f.adjunto.updateValueAndValidity();
    } else {
      this.f.adjunto.setValidators( [ Validators.required ] );
      this.f.adjunto.updateValueAndValidity();
    }
  }

  async agregar() {
    this.submittedExcepcion = true;

    if (this.formulario.invalid) {
      this.formulario.markAllAsTouched();
      return;
    }

    this.guardandoExcepcion = true;

    const formData = this.formulario.value;

    const objeto = {
      idsVinculacion: formData.vinculacion,
      idsRoles: formData.rol,
      idPolitica: this.politica.idPolitica,
      idRegla: formData.regla,
      idNivel: formData.nivel,
      indicadorManejaAdjunto: formData.manejaAdjunto,
      idRespaldo: formData.adjunto,
      definicionExcepcion: formData.definicioExcepcion,
      indicadorDetener: false
    }

    try {
      await this.talanqueraService.guardarAlerta(objeto).toPromise();
      this.actualizarListados();
      this.limpiar()
    } catch (error) {
      console.error('Error submitting data:', error);
    } finally {
      this.submittedExcepcion = false;
      this.guardandoExcepcion = false;
    }
  }

  editarPoliticaExcepcion(item) {
    console.log(item)
    if (item) {
      this.f.id.setValue( item.idPoliticaTalanquera );
      this.f.regla.setValue( item.idRegla );
      this.f.vinculacion.setValue( [item.idTipoVinculacion] );
      this.f.manejaAdjunto.setValue( item.indicadorAdjunto );
      this.f.adjunto.setValue( item.idRespaldo );
      this.f.nivel.setValue( item.idNivel );
      this.f.definicioExcepcion.setValue( item.definicionExcepcion );
      this.f.rol.setValue(item.roles.map(role => role.idRol));
      this.formulario.get('regla')?.disable();
      this.formulario.get('vinculacion')?.disable();
    }
    this.item = item;
    this.validarAdjunto()
  }

  async editarExcepcion() {
    this.submittedExcepcion = true;

    if (this.formulario.invalid) {
      this.formulario.markAllAsTouched();
      return;
    }

    this.guardandoExcepcion = true;

    const formData = this.formulario.value;

    const objeto = this.item;

    objeto.indicadorAdjunto = formData.manejaAdjunto;
    objeto.idRespaldo = !formData.manejaAdjunto ? null : formData.adjunto;
    objeto.idNivel = formData.nivel;
    objeto.definicionExcepcion = formData.definicioExcepcion;

    // Extraer los IDs de roles configurados
    const idsConfigurados = new Set(this.item.roles.map((rol) => rol.idRol));
    const idsEditados = new Set(formData.rol);

    const listadoNuevo: any[] = [];

    // Procesar roles configurados
    this.item.roles.forEach((rolConfig) => {
      const nuevoObjeto = rolConfig;
      nuevoObjeto.indicadorHabilitado = idsEditados.has(nuevoObjeto.idRol)
      listadoNuevo.push(nuevoObjeto);
    });

    // Agregar roles nuevos con indicadorHabilitado en true
    Array.from(idsEditados).forEach((idRol) => {
      if (!idsConfigurados.has(idRol)) {  // Solo agregamos si es un rol nuevo
        // Buscar un rol configurado cualquiera para tomar sus valores de política
        const idPoliticaTalanqueraRol = objeto ? objeto.idPoliticaTalanqueraRol : '';
        const idPoliticaTalanquera = objeto ? objeto.idPoliticaTalanquera : '';

        const nuevoObjeto = {
          idPoliticaTalanqueraRol: null,
          idPoliticaTalanquera: idPoliticaTalanquera,
          idRol: idRol,
          indicadorHabilitado: true
        };
        listadoNuevo.push(nuevoObjeto);
      }
    });
    console.log(listadoNuevo)
    try {
      await this.talanqueraService.actualizar(objeto).toPromise();
      await this.talanqueraService.actualizarRoles(listadoNuevo).toPromise();
      this.actualizarListados();
      this.limpiar()
    } catch (error) {
      console.error('Error submitting data:', error);
    } finally {
      this.submittedExcepcion = false;
      this.guardandoExcepcion = false;
    }
  }

  inhabilitarPoliticaExcepcion( registro ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'inhabilitar',
      accept: async () => {
        this.guardandoExcepcion = true;
        const objeto = registro;
        objeto.indicadorHabilitado = false;
        try {
          let response;
          response = await this.talanqueraService.deshabilitarReglaTalanquera(objeto).toPromise();
          this.actualizarListados();
          this.limpiar()
        } catch (error) {
          console.error('Error submitting data:', error);
        } finally {
          this.guardandoExcepcion = false;
        }
      },
      reject: () => {
      }
    } );
  }

  limpiar() {
    // Reinicia los valores del formulario
    this.formulario.reset();
    this.submittedExcepcion = false;

    // Habilita todos los campos del formulario
    Object.keys(this.formulario.controls).forEach((campo) => {
      this.formulario.get(campo)?.enable();
    });

    // Limpiar el item seleccionado
    this.item = null;
    this.submittedExcepcion = false;
    this.listasTiposVinculacionesDetener = this.listasTiposVinculaciones;
    this.listasTiposVinculacionesExcepcion = this.listasTiposVinculaciones;

    this.validarAdjunto();
  }

  async actualizarListados() {
    const listaTalanquera = await this.talanqueraService.listado(this.politica.idPolitica).toPromise();

    this.registrosExcepcion = []
    this.registrosDetener = []

    this.registrosExcepcion = listaTalanquera.filter(item => item.indicadorDetener === false);
    this.registrosDetener = listaTalanquera.filter(item => item.indicadorDetener === true);
  }

  async guardarEstadoPoliticaDetener() {
    console.log(this.estadoDetener);
    console.log(this.politica);
    if (!this.estadoDetener) {
      this.submittedEstadoDetener = true;
      return;
    } else {
      this.submittedEstadoDetener = false;
    }

    if (!this.politica || !this.politica.idPolitica) {
      this.nav.setMesage(4, {
        severity: "info",
        summary: this.nav.buscarMensaje("LBL_INFORMACION"),
        detail: this.nav.buscarMensaje("TALANQUERA.MSG_GUARDARPOLITICA"),
      });
      return;
    }
    try {
      if (this.estadoDetener) {
        this.guardandoEstadoDetener = true;
        this.politica.idEstado = this.estadoDetener;
        const politicaActualizada = await this.politicaService.actualizar(this.politica).toPromise();
        if (politicaActualizada) {
          this.habilitarEdicionEstado = false;
          this.nav.setMesage( 2 );
          console.log(politicaActualizada)
        }
      }
    } catch (error) {
      console.error('Error submitting data:', error);
    } finally {
      this.guardandoEstadoDetener = false;
    }
  }

  habilitarEstadoPoliticaDetener() {
    this.habilitarEdicionEstado = !this.habilitarEdicionEstado
  }
}
